import type {AssetConfigurationDto} from '../../../types'
import {DRIVE, INITIAL_LAYOUT} from '../constants'
import type {KilnConfigState} from '../types'

export const getKilnConfig = (assetConfig: AssetConfigurationDto): KilnConfigState => {
  return {
    ...assetConfig.payload,
    layout: {
      ...INITIAL_LAYOUT,
      ...assetConfig.payload.layout,
      interactiveOverlayHeight: Math.max(
        assetConfig.payload.layout.interactiveOverlayHeight,
        DRIVE.OVERLAY_HEIGHT_SINGLE
      )
    }
  }
}
